import { jsx, jsxs } from "react/jsx-runtime";
import { Avatar, Flex, Typography } from "antd";
const { Text } = Typography;
const OptionRender = ({ option, token, inLabel = false }) => {
  return /* @__PURE__ */ jsxs(
    Flex,
    {
      title: "",
      align: "center",
      justify: "start",
      gap: 8,
      style: {
        flexDirection: inLabel ? "row-reverse" : "row"
      },
      children: [
        /* @__PURE__ */ jsx(
          Avatar,
          {
            src: option.iconUrl,
            style: {
              height: 22,
              width: 22,
              flexShrink: 0,
              borderRadius: "50%",
              backgroundColor: token.colorWhite
            }
          }
        ),
        /* @__PURE__ */ jsxs(Flex, { vertical: true, align: "start", gap: 2, children: [
          /* @__PURE__ */ jsx(
            Text,
            {
              style: {
                color: token.colorTextBase,
                fontWeight: 600
              },
              children: option.name
            }
          ),
          !inLabel && /* @__PURE__ */ jsx(
            Text,
            {
              style: {
                color: token.colorTextBase,
                fontWeight: 400,
                fontSize: token.fontSizeXS
              },
              children: option.moreInfo
            }
          )
        ] })
      ]
    }
  );
};
var stdin_default = OptionRender;
export {
  stdin_default as default
};
